export enum MultiDayChefitStatus {
    ACTIVE = "ACTIVE",
    CANCELLED = "CANCELLED",
    PENDING = "PENDING"
}